import { differenceInMonths } from 'date-fns'

import { AccountDetailedDto } from '@model/AccountDetailedDto'

export const isAccountOlderThanOneMonth = (
  accountDetailed: AccountDetailedDto | undefined
): boolean => {
  const createdDate = getAccountCreatedDate(accountDetailed)
  return isAccountOlderThan(createdDate, differenceInMonths, 1)
}

const isAccountOlderThan = (
  accountCreatedDate: string | undefined | null,
  differenceFn: (dateNow: Date, dateOld: Date) => number,
  threshold: number
): boolean => {
  if (!accountCreatedDate) {
    return false
  }

  const accountCreated = new Date(accountCreatedDate)
  const currentDate = new Date()

  const difference = differenceFn(currentDate, accountCreated)

  return difference >= threshold
}

const getAccountCreatedDate = (accountDetailed: AccountDetailedDto | undefined) => {
  return accountDetailed?.createdDate || undefined
}
